export const accessCodes = `[
  {
    "name": "SG-ENF-ITGroup",
    "id": "b1371679-f107-4493-bc57-d6b7f38fa887",
    "role": "ADMIN"
  },
  {
    "name": "SG-ALL-Purchase Ledger",
    "id": "a0855526-74e1-4e33-b6c2-53602585eecd",
    "role": "USER"
  },
  {
    "name": "SG-ALL-Purchasing",
    "id": "6451537c-9dc6-4227-8cd9-8d52a36393c3",
    "role": "USER"
  },
  {
    "name": "SG-ALL-Warehouse",
    "id": "99fb9748-5bb6-4ee9-9b29-fcc53b50dbf3",
    "role": "USER"
  }
]`